import { render, staticRenderFns } from "./view-policy.vue?vue&type=template&id=74a0e18c"
import script from "./view-policy.vue?vue&type=script&lang=js"
export * from "./view-policy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports